/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AdditionalInformationInner {
  /**
   * Unique ID for this info.
   */
  infoCode?: string;
  /**
   * Technical details. NOT intended for display at presentation layer. This will never contain sensitive technical details. Especially no stack traces.
   */
  systemMsg?: string;
  /**
   * User message in german. For some use cases there will be a user message.
   */
  userMsg?: string;
}
